<template src="./ClusterPaciente.html"></template>

<script>
import VueApexCharts from "vue-apexcharts";

import moment from "moment-timezone";
import {
  readInfoTherapyPatient,
  leerLista,
  cancelTherapyPatient,
  readScoresTherapyPatient,
  readSummaryTherapyPatient,
} from "../../../apiService/request/CrudTerapias";
import { clustersPatient } from "../mocks";
import { consultarFormularioLLenopacienteTerapia } from "../../../apiService/request/CrudFormulario";
import FormulariosTerapias from "../FormulariosTerapias/FormulariosTerapias";
import SummaryText from "../SummaryText/SummaryText";
export default {
  data() {
    return {
      sesionsData: [],
      sessionUp: false,
      formulariosEsquemas: {},
      seeForms: false,
      selected: false,
      documento: 0,
      fechaCompletado: [],
      nombreResumen: "Terapia",
      scoreTherapy: {},
      textoResumen: "",
      showGraphic: true,
      keyCloster: 0,
      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "series-1",
          data: [],
        },
      ],
    };
  },
  methods: {
    regresar() {
      try {
        if (!this.showGraphic) {
          this.showGraphic = true;
          this.textoResumen = "";
          this.readSummaryTherapyPatient();
          this.nombreResumen = "terapia";
          this.seeForms = false;
          this.keyCloster += 1;
        } else {
          this.$emit("regresar");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async readSummaryTherapyPatient() {
      try {
        const response = await readSummaryTherapyPatient(
          this.ClusterData.docId
        );
        if (response && response.data && response.data.data) {
          this.textoResumen = response.data.data;
        }
      } catch (error) {}
    },
    async readScoresTherapyPatient() {
      try {
        this.$store.dispatch("setCargando", true);
        await this.readSummaryTherapyPatient();
        const response = await readScoresTherapyPatient(this.ClusterData.docId);
        if (response && response.data && response.data.data) {
          this.options.xaxis.categories = response.data.data.nombre_sesiones;
          this.series[0].data = response.data.data.calificacion_sesiones;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async readClusterPatient() {
      this.sessionUp = false;
      this.documento = parseInt(this.ClusterData.documentPatient);
      try {
        this.$store.dispatch("setCargando", true);
        const response = await readInfoTherapyPatient(
          this.documento,
          this.ClusterData.docId
        );
        if (response && response.data && response.data.data) {
          this.sesionsData = response.data.data;
          this.sesionsData.forEach((element, index) => {
            this.fechaCompletado.push(
              moment(element.fecha_completado).format("DD MMM [de] YYYY, h:mm a")
            );
            if (this.fechaCompletado[index] === "Invalid date") {
              this.fechaCompletado[index] = " ";
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async cancelCluster() {
      let respuesta = confirm("¿Está seguro que desea cancelar la terapia?.");
      if (respuesta) {
        try {
          this.$store.dispatch("setCargando", true);
          const respuesta = await cancelTherapyPatient(
            this.ClusterData.docId,
            this.documento,
            this.$store.state.provider_email
          );
        } catch (err) {
          console.log("error:cancelando", err);
        } finally {
          this.regresar();
          this.$store.dispatch("setCargando", false);
        }
      } else {
      }
    },
    async selectSession(formularios, nombreSesion, index) {
      this.showGraphic = false;
      if (this.sesionsData[index].resumen_sesion !== "") {
        this.textoResumen = this.sesionsData[index].resumen_sesion;
      } else {
        this.textoResumen = "";
      }
      this.nombreResumen = "Sesión";
      this.sessionUp = true;
      this.selected = true;
      this.formulariosEsquemas = [];
      const respuesta = [];
      this.removeColor();
      this.changeColor(index);
      try {
        if (formularios.length == 0 && this.textoResumen === "") {
          alert(
            `El paciente no cuenta con formularios o resumen para la sesión ${nombreSesion}.`
          );
          this.sessionUp = false;
          this.selected = false;
          this.showGraphic = true;
          await this.readSummaryTherapyPatient();
          this.nombreResumen = "terapia";
          this.removeColor();
        }
        this.$store.dispatch("setCargando", true);
        formularios.forEach(async (element) => {
          const response = await consultarFormularioLLenopacienteTerapia(
            element.tipo_esquema,
            element.id
          );
          if (response && response.data && response.data.data) {
            respuesta.push(response.data.data);
          }
        });
        this.formulariosEsquemas = respuesta;
      } catch (error) {
        console.log(error);
      } finally {
        this.seeForms = true;
        this.$store.dispatch("setCargando", false);
      }
    },
    removeColor() {
      this.sesionsData.forEach((element) => {
        const cluster = document.getElementById(element.index_sesion);
        cluster.classList.remove("cluster--selected");
      });
    },
    changeColor(index) {
      const cluster = document.getElementById(index);
      cluster.className += " cluster--selected";
    },
  },
  created() {
    this.readClusterPatient();
    this.readScoresTherapyPatient();
  },

  components: {
    FormulariosTerapias,
    SummaryText,
  },
  props: {
    ClusterData: {
      type: Object,
      default: [],
    },
  },
};
</script>

<style lang="scss" scoped src="./ClusterPaciente.scss">
</style>


// WEBPACK FOOTER //
// src/components/Terapias/ClusterPacientes/ClusterPaciente.vue